import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { product_valuation_config, fetch_product_valuation_config,fetch_product_details  } from 'services/apiSrv';
import styled from 'styled-components';
import { useQuery } from 'react-query';
import TableComponent from 'components/widgets/table';
import Loader from 'components/widgets/loader';

const DEFAULT_CONFIG = {
  valuationRequired: true,
  selectedConfig: '',
  issuancePeriod: 'FULL',
  postIssuancePeriod:"FULL",
  certificateIssuance:"AUTO"
};

const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
`;

const Title = styled.h2`
  margin: 0 0 18px 0;
  color: #333; /* revert to app default title color */
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 220px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-weight: 600;
  margin-bottom: 6px;
  color: #333; /* revert to default label color */
`;

const Select = styled.select`
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  color: #000;
  &:focus {
    outline: none;
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24,144,255,0.08);
  }
`;

const RadioGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
`;

const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  justify-content: flex-end; /* align buttons to the right */
  width: 100%;
`;

const Button = styled.button`
  padding: 8px 14px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.08);
  background: ${(p) => (p.primary ? '#1890ff' : '#f3f3f3')};
  color: ${(p) => (p.primary ? '#fff' : '#000')};
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; }
  &:hover { filter: brightness(0.98); }
`;

const Message = styled.div`
  color: ${(p) => (p.error ? 'crimson' : 'green')};
  margin-top: 8px;
`;

export default function ValuationProductConfig() {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const {id}= useParams()



    const { id: productSystemRef} = useParams()

    const { data: ii, isProductDetailsLoading, isProductDetailsError, errorProductDetails, refetch } = useQuery({
      queryKey: ['productDetails', productSystemRef],
      queryFn: () => fetch_product_details(productSystemRef),
      enabled: !!productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    });
  
   const productValuationConfig = ii?.data?.[0]?.productValuationConfig;

    // Make a safe copy (array or empty array)
    const configs = [productValuationConfig] 
      console.log("dataiii", configs)
    // if (isLoading) {
    //   return <Loader/>;
    // }
  
    // if (isError) {
    //   return <p>Error fetching product details: {error?.message || 'Something went wrong'}</p>;
    // }
  
    // if (!data?.data) {
    //   return <p>No product data available.</p>;
    // }

 


  async function get_product_valuation_config(){
    const res = await fetch_product_valuation_config()
    return res.data 
  }

  const { data: valConfigs = [], isLoading, error: configError } = useQuery({
    queryKey: ['product-valuation-config'],
    queryFn: async () => {
      const res = await get_product_valuation_config();
      if (res.error) throw new Error(res.error.message);
      return res;
    },
  });


  // console.log("configs val", valConfigs)


  
    // const { policyNumberConfig } = data.data[0];
    // console.log("POLICYNUMBER==", policyNumberConfig)




      // isValuationRequired
      // : 
      // true
      // motorPolicyCertificateIssuance
      // : 
      // "AUTO"
      // postValuationCertificatePeriod
      // : 
      // "FULL"
      // preValuationCertificatePeriod
      // : 
      // "FULL"
      // valuationConfigSystemRef
      // : 
      // "71d80263-79b7-43b8-8c78-002d59999be8"

        

    const valconfigTableFields = [
      { name: 'Is ValuationRequired' },
      { name: 'Policy Cert Issuance' },
      { name: 'Pre valuation period' },
      { name: 'Max Period' },
      { name: 'Ref' },
    ];

    const  valRowData = [
      { type: 'text', field: 'isValuationRequired' },
      { type: 'text', field: 'motorPolicyCertificateIssuance' },
      { type: 'text', field: 'preValuationCertificatePeriod' },
      { type: 'text', field: 'maximumValuationPeriod' },
      { type: 'text', field: 'valuationConfigSystemRef' },
    ];



  useEffect(() => {
    let mounted = true;
    async function loadConfig() {
      setLoading(true);
      try {
        // mock load
        await new Promise((r) => setTimeout(r, 200));
        if (mounted) {
          setConfig((c) => ({ ...c, selectedConfig: 'standard', name: 'default' }));
        }
      } catch (err) {
        if (mounted) setError('Failed to load configuration.');
      } finally {
        if (mounted) setLoading(false);
      }
    }
    loadConfig();
    return () => { mounted = false; };
  }, []);

  function updateField(field, value) {
    setConfig((prev) => ({ ...prev, [field]: value }));
    setMessage(null);
    setError(null);
  }

  function validate() {
    // if (!config.name || config.name.trim() === '') return 'Name is required.';
    if (config.valuationRequired && !config.selectedConfig) return 'Please choose a valuation configuration.';
    return null;
  }

  async function handleSave(e) {
    if (e && e.preventDefault) e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      setMessage(null);
      return;
    }
    const payload={
      productSystemRef:id,
      productValuationConfig:{
            isValuationRequired:config.valuationRequired,
            valuationConfigSystemRef:config.valuationRequired?config.selectedConfig :"",
            motorPolicyCertificateIssuance:config.valuationRequired?config.certificateIssuance :"",
            preValuationCertificatePeriod:config.valuationRequired?config.issuancePeriod :"",
            postValuationCertificatePeriod:config.valuationRequired?config.issuancePeriod:""
         }
    }
    console.log("payload===", payload)
    const res= await product_valuation_config(payload)

    console.log("==product config", res.data)
    setSaving(true);
    setError(null);
    setMessage(null);
    try {
      // mock save
      await new Promise((r) => setTimeout(r, 500));
      setMessage('Configuration saved successfully. (mock)');
    } catch (err) {
      setError('Failed to save configuration.');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div>Loading valuation configuration...</div>;

  return (
    <>
        <Container>
      <Title>Valuation Configuration</Title>
      <Form onSubmit={handleSave}>
     

        <Field>
          <Label>Is valuation required?</Label>
          <RadioGroup role="radiogroup" aria-label="valuation-required">
            <RadioLabel>
              <input
                type="radio"
                name="valuationRequired"
                checked={!!config.valuationRequired}
                onChange={() => updateField('valuationRequired', true)}
                disabled={saving}
              />
              Yes
            </RadioLabel>
            <RadioLabel>
              <input
                type="radio"
                name="valuationRequired"
                checked={!config.valuationRequired}
                onChange={() => updateField('valuationRequired', false)}
                disabled={saving}
              />
              No
            </RadioLabel>
          </RadioGroup>
        </Field>

        {config.valuationRequired && (
          <div className='space-y-4'> 
       <Field>
      <Label>Which config to use</Label>
      <Select
        value={config.selectedConfig || ""}
        onChange={(e) => updateField('selectedConfig', e.target.value)}
        disabled={saving}
      >
        <option value="">Choose config</option>
        {valConfigs.length === 0 ? (
          <option disabled>No valuation configs available</option>
        ) : (
          valConfigs.map((n) => (
            <option
              key={n.valuationConfigSystemref}
              value={n.valuationConfigSystemref}
            >
              {n.valuationConfigName}
            </option>
          ))
        )}
      </Select>
    </Field>

        <Field>
          <Label>Certificate Issuance</Label>
          <Select
            value={config.certificateIssuance}
            onChange={() => updateField('certificateIssuance', "AUTO")}
            disabled={saving}
          >
            <option value="">-- select--</option>
            <option value="AUTO">Auto</option>
            <option value="MANUAL">Manual</option>
          </Select>
        </Field> 
         <Field>
          <Label>Motor certificate Pre issuance period</Label>
          <RadioGroup role="radiogroup" aria-label="issuance-period">
            <RadioLabel>
              <input
                type="radio"
                name="issuancePeriod"
                checked={config.issuancePeriod === 'FULL'}
                onChange={() => updateField('issuancePeriod', 'FULL')}
                disabled={saving}
              />
              Full
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="issuancePeriod"
                checked={config.issuancePeriod === 'two_month'}
                onChange={() => updateField('issuancePeriod', 'two_month')}
                disabled={saving}
              />
              Two month
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="issuancePeriod"
                checked={config.issuancePeriod === 'FULL'}
                onChange={() => updateField('issuancePeriod', 'FULL')}
                disabled={saving}
              />
              Full month
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="issuancePeriod"
                checked={config.issuancePeriod === 'manual'}
                onChange={() => updateField('issuancePeriod', 'manual')}
                disabled={saving}
              />
              Manual
            </RadioLabel>
          </RadioGroup>
        </Field>

        <Field>
          <Label>Motor certificate Post issuance period</Label>
          <RadioGroup role="radiogroup" aria-label="issuance-period">
            <RadioLabel>
              <input
                type="radio"
                name="postIssuancePeriod"
                checked={config.issuancePeriod === 'one_month'}
                onChange={() => updateField('postIssuancePeriod', 'one_month')}
                disabled={saving}
              />
              One month
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="postIssuancePeriod"
                checked={config.issuancePeriod === 'two_month'}
                onChange={() => updateField('postIssuancePeriod', 'two_month')}
                disabled={saving}
              />
              Two month
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="postIssuancePeriod"
                checked={config.postIssuancePeriod === 'FULL'}
                onChange={() => updateField('postIssuancePeriod', 'FULL')}
                disabled={saving}
              />
              Full month
            </RadioLabel>

            <RadioLabel>
              <input
                type="radio"
                name="postIssuancePeriod"
                checked={config.postIssuancePeriod === 'MANUAL'}
                onChange={() => updateField('postIssuancePeriod', 'MANUAL')}
                disabled={saving}
              />
              Manual
            </RadioLabel>
          </RadioGroup>
        </Field>
          </div>
          
        )}

    

        {error && <Message error>{error}</Message>}
        {message && <Message>{message}</Message>}

        <ButtonRow>
          <Button type="submit" primary disabled={saving}>{saving ? 'Saving...' : 'Save'}</Button>
          <Button
            type="button"
            onClick={() => {
              setConfig(DEFAULT_CONFIG);
              setMessage(null);
              setError(null);
            }}
            disabled={saving}
          >
            Reset
          </Button>
        </ButtonRow>
      </Form>


    </Container>
    <div style={{ paddingTop: "1.2em" }}>
        <h2>Valuation Configs</h2>
        <TableComponent
            title={``}
            table_fields={valconfigTableFields}
            row_data={valRowData}
            table_data={configs}
          />
    </div>

    </>

  );
}
